import React, { FC, useCallback } from 'react';
import styled from 'styled-components';

import ConditionRow from './ConditionRow';
import { StyledDropdown } from 'src/presentation/components/pages/rules/shared/StyledComponents';
import { ChatCampaignCondition as ChatCampaignConditionType } from 'src/actions/rules/condition';
import useChatCampaigns from '../hooks/useChatCampaigns';
import { InternalLink } from 'src/presentation/components/pages/shared/Links';

type ChatCampaignConditionProps = {
  condition: ChatCampaignConditionType;
  index: number;
  onDelete: Function;
  onUpdate: Function;
};

const ChatCampaignCondition: FC<ChatCampaignConditionProps> = ({ condition, index, onDelete, onUpdate }) => {
  const onProactiveChatChange = useCallback(
    val => {
      condition.setValue(val);
      onUpdate({ condition, index });
    },
    [condition, index, onUpdate]
  );

  const { loadingState, values: proactiveChatOptions } = useChatCampaigns();
  if (loadingState === 'loading') return null;

  function renderCampaignLink(condition) {
    if (condition.value) {
      return (
        <StyledInternalLink target="_blank" to={`/proactive-chat/${condition.value}`}>
          View campaign
        </StyledInternalLink>
      );
    }
  }

  return (
    <ConditionRow index={index} onDelete={onDelete} text="Proactive Chat is">
      <StyledDropdown
        onSelect={onProactiveChatChange}
        options={proactiveChatOptions}
        placeholder="Select chat campaign"
        searchable
        value={condition.value}
      />
      {renderCampaignLink(condition)}
    </ConditionRow>
  );
};

const StyledInternalLink = styled(InternalLink)`
  color: ${p => p.theme.colors.green400};
  margin-left: 8px;
  margin-right: 8px;
`;

export default ChatCampaignCondition;
